export default "__VITE_ASSET__9K0FgvfD__"